import { QUESTION_SET_CURRENT, RESET_USER } from '../actions'

function CurrentIntroQuestionsReducer(state = 0, action) {
    switch (action.type) {
        case QUESTION_SET_CURRENT:
            return action.payload
        case RESET_USER:
            return 0
        default:
            return state
    }
}

export default CurrentIntroQuestionsReducer



// WEBPACK FOOTER //
// ./src/reducers/currentIntroQuestion.js